import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Listing from './pages/Listing';
import Register from './pages/Register';
import Contact from './pages/Contact';
import ICADLA from './components/ICADLA';
import ICADLABookkeeperRegister from './components/ICADLABookkeeperRegister';
import ICADLARequesterRegister from './components/ICADLARequesterRegister';
import './styles/main.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Main Website Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/listing" element={<Listing />} />
          <Route path="/register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* ICADLA Promotional Routes */}
          <Route path="/icadla" element={<ICADLA />} />
          <Route path="/icadla/bookkeeper" element={<ICADLABookkeeperRegister />} />
          <Route path="/icadla/requester" element={<ICADLARequesterRegister />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;